import * as React from "react"
type Props = {
  title: string,
  body: string
}

export const Show = (props: Props) : JSX.Element => {
  document.title = document.title ? props.title + " " + document.title : props.title

  return (
    <div>
      <div className="page-section page-section--pt">
        <div className="grid-container">
          <div className="grid-70 suffix-15 prefix-15 tablet-grid-70 tablet-suffix-15 tablet-prefix-15">
            <h1 className="page-section__title">{props.title}</h1>
            <div dangerouslySetInnerHTML={{__html: props.body}} />
          </div>
        </div>
      </div>
    </div>
   )
}
